import { useIntl, FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { MaintenancePageLayout } from '@commercetools-frontend/application-components';
import { SUPPORT_PORTAL_URL } from '@commercetools-frontend/constants';
import { Link } from '@commercetools-frontend/ui-kit';
import { STATUS_PAGE_URL } from '@commercetools-local/constants/misc';
import messages from './messages';
import PageApplicationDisbaledSvg from './page-application-disabled.svg';

// eslint-disable-next-line react/display-name
const getSupportPortalLink = (msg) => (
  <Link to={SUPPORT_PORTAL_URL} isExternal>
    {msg}
  </Link>
);
const getStatusPageLink = (msg) => (
  <Link to={STATUS_PAGE_URL} isExternal>
    {msg}
  </Link>
);

const getMessagesForReason = (reason) => {
  switch (reason) {
    case 'load-reduction': {
      return messages.loadReduction;
    }
    default: {
      return messages.notFound;
    }
  }
};
const PageApplicationDisabled = () => {
  const location = useLocation();
  const intl = useIntl();

  const reason = location.query.reason;
  const messagesForReason = getMessagesForReason(reason);

  return (
    <MaintenancePageLayout
      imageSrc={PageApplicationDisbaledSvg}
      title={<FormattedMessage {...messagesForReason.title} />}
      label={intl.formatMessage(messagesForReason.title)}
      paragraph1={
        <FormattedMessage
          {...messagesForReason.explanation}
          values={{
            'support-portal-link': getSupportPortalLink,
            'status-page-link': getStatusPageLink,
          }}
        />
      }
    />
  );
};
PageApplicationDisabled.displayName = 'PageNotFound';

export default PageApplicationDisabled;
